import HeaderSectionBlood from '../../components/Header/HeaderSectionBlood';
//import { useTranslation } from '../../language';


export default function LabfinderText() {

      
    return (

            <HeaderSectionBlood

                headline_p1 = "Find the "
                headline_grey = "certified laboratory "
                headline_p2 = "near you for blood draw"

            />

            
)
}